import React from 'react'
import Slider from "react-slick";
import {Link} from 'react-scroll'


import project1 from '../projects/event-1.JPG'
import project2 from '../projects/event-2.JPG'
import project3 from '../projects/event-3.JPG'
import project4 from '../projects/event-4.JPG'

import projectLC1 from '../projects/lc-1.JPG'
import projectLC2 from '../projects/lc-2.JPG'
import projectLC3 from '../projects/lc-3.JPG'
import projectLC4 from '../projects/lc-4.JPG'


import projectLA1 from '../projects/LA-1.JPG'
import projectLA2 from '../projects/LA-2.JPG'
import projectLA3 from '../projects/LA-3.JPG'
import projectLA4 from '../projects/LA-4.JPG'


import projectca1 from '../projects/chat-1.JPG'
import projectca2 from '../projects/chat-2.JPG'
import projectca3 from '../projects/chat-3.JPG'
import projectca4 from '../projects/chat-4.JPG'


import projectothers1 from '../projects/gf-foundation.JPG'
import projectothers2 from '../projects/pdlogo.png'
import projectothers3 from '../projects/logo_clarks.png'


//print project
import projectothers5 from '../projects/others-1.JPG'
import projectothers6 from '../projects/children-centre.JPG'
import projectothers7 from '../projects/affnoo-logo.png'
import projectothers8 from '../projects/internation-house-of-tea.png'


function resumeportafolio() {    
    const settings = {
        dots: true,
        arrows:true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 15000,
        slidesToShow: 1,
        slidesToScroll: 1
      };   
   
        return (           
            <div id="latest" className="featured relative d-xs-none">
            <div className="container-fluid ">                
            <div className="min-vh-100 slide-content topheader-title background" style={{overflow: "visible",height: "auto"}} >         
                <h3 className="text-center text-white">Latest Projects</h3>  
                <p className="text-center text-white">Below is short list of the many projects I have worked independently or as a part of a team where my involvement was significant, I included some of the latest ones to highlight the recent technologies and roles I had been part of. <br>                
                </br>
                </p>
                
                <Slider {...settings} className="text-center container">
                    <div className="card">
                        <h3>Event / Conference Software</h3>
                        <div >                                                        
                            <div className="row text-center col-lg-12">
                            <a href={project1} target="_blank" rel="noopener noreferrer" className="col-lg-3 "><img alt="project screenshot"src={project1} /></a>
                            <a href={project2} target="_blank" rel="noopener noreferrer" className="col-lg-3 d-xs-none d-lg-block"><img alt="project screenshot"src={project2} /></a>   
                            <a href={project3} target="_blank" rel="noopener noreferrer" className="col-lg-3 d-xs-none d-lg-block"><img alt="project screenshot"src={project3} /></a>   
                            <a href={project4} target="_blank" rel="noopener noreferrer" className="col-lg-3 d-xs-none d-lg-block"><img alt="project screenshot"src={project4} /></a>                                                                               
                            </div>
                            
                            <div className="row text-start col-lg-12">
                                <div className="col-lg-6">
                                <div className="card-text">
                                <br></br><br></br>
                                    <h2 className="featured h4" >About the Project:</h2>
                                    <p>Project developed to replace live events to an online platform due to traveling restrictions across the world.<br></br>
                                    Part of the exciting challenges on this project was to recreate the in person experience and networking capabilites for the online attendees.
                                    <br></br><br></br>
                                    The project was database driven which included events, livestreaming, chat system, attendees, leads tracking for participating sponsors , interactive expo booths, realtime-schedule, forums, access levels, and networking capabilities. *Access only to paid users.                                  
                                    </p>
                                    </div><br></br>                                    
                                </div>

                                <div className="col-lg-6">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >My contribution to the project:</h2><br></br>
                                <span className="">Database engineering, Application Logic, Front and Backend Prgoramming, UI Design, UX Programming.</span><br></br>
                                    <br></br><span className="">Technologies used on this project: SQL, .Net, ASPx, js, Ajax,Jquery,HTML,Css.</span>
                                    </div>
                                </div>
                            </div>

                            <br></br>
                        </div>
                    </div>
                    <div className="card">
                    <h3>Customer Order Application</h3>
                        <div>                        
                        <div className="row text-center col-lg-12">
                            <a href={projectLC1} target="_blank" rel="noopener noreferrer" className="col-lg-3"><img alt="project screenshot"src={projectLC1} /></a>
                            <a href={projectLC2} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLC2} /></a>   
                            <a href={projectLC3} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLC3} /></a>   
                            <a href={projectLC4} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLC4} /></a>                                                                               
                        </div>
                        <div className="row text-start col-lg-12">
                            <div className="col-lg-6">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >About the Project:</h2><br></br>
                                <p>
                                <br></br>Web Application created for Lakehead Cleaners, the application was build with the purpose of organize,maintain and track orders from clients.<br>
                                        </br> <br></br>In this case the clients are mining companies that place orders on the system via the web application which holds settings and data for each individual company
                                        and its employees. This system includes very specific and realtime settings for each order placed, the web application besides the order management portion allows communication
                                        between clients and management based per orders, email alerts, inventory tracking. This web application is fully done with scalability features.                                 
                                </p>
                                       
                                    </div>
                            </div>
                            <div className="col-lg-6">
                            <div className="card-text">
                            <br></br><br></br>
                            <h2 className="featured h3" >My contribution to the project:</h2><br></br>
                            <span className="">Database engineering, Application Logic, Front and Backend Programming, UI Design, UX Programming.</span>
                                    <br></br><br></br><span className="">Technologies used on this project: MySQL, PHP, Javascript, bootstrap, CSS, HTML5.</span>
                                    </div>
                            </div>
                        </div>
                        
                           
                        </div>
                    </div>
                    <div className="card">
                    <h3>Learning Academy Software</h3>
                        <div>
                        
                            <div className="row text-center col-lg-12">
                                <a href={projectLA1} target="_blank" rel="noopener noreferrer" className="col-lg-3"><img alt="project screenshot"src={projectLA1} /></a>
                                <a href={projectLA2} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLA2} /></a>   
                                <a href={projectLA3} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLA3} /></a>   
                                <a href={projectLA4} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectLA4} /></a>                                                                               
                            </div>
                            <div className="row text-start col-lg-12">
                                <div className="col-lg-6">
                                    <div className="card-text">
                                    <br></br><br></br>
                                    <h2 className="featured h3" >About the Project:</h2><br></br>
                                        
                                        <p>
                                            An Online Learning Platform for Contact Center Professionals to sign up and complete courses related to the Contact Center Industry. 
                                            <br>
                                            </br><br></br>                                                                      
                                            The project includes a full backend system for teachers/content creators to build and customize their own course. Software includes connections
                                            with Youtube API to get watch times from studends to validate completion of the course. Customizable tests, notes saving for students as well as supervisor access for company managers
                                            to manage/track employees progression.
                                        </p>

                                        </div>
                                </div>
                                <div className="col-lg-6">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >My contribution to the project:</h2><br></br>
                                <span className="">Database engineering, Application Logic, Front and Backend Programming, UI Design, UX Programming.</span>
                                        <br></br><br></br><span className="">Technologies used on this project: MySQL, PHP, Javascript,AJAX, CSS, HTML5.</span>
                                        </div>
                                </div>
                            </div>
                            
                           
                        </div>
                    </div>
                    <div className="card">
                    <h3>Social Network Chat</h3>
                        <div>
                        
                        <div className="row text-center col-lg-12">
                            <a href={projectca1} target="_blank" rel="noopener noreferrer" className="col-lg-3"><img alt="project screenshot"src={projectca1} /></a>
                            <a href={projectca2} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectca2} /></a>   
                            <a href={projectca3} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectca3} /></a>   
                            <a href={projectca4} target="_blank" rel="noopener noreferrer" className="col-lg-3  d-xs-none d-lg-block"><img alt="project screenshot"src={projectca4} /></a>                                                                               
                        </div>
                        <div className="row text-start col-lg-12">
                            <div className="col-lg-6">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >About the Project:</h2><br></br>
                                <p>
                                This project was part of a re-build of an older chat system. 
                                       <br>
                                       </br><br></br>                                                                      
                                      Based on current trends on social media regarding networking messaging systems, the implementation of a new and more standarized communication channel was needed
                                      to keep up with the current market.
                                </p>
                                    
                                    </div>
                            </div>
                            <div className="col-lg-6">
                            <div className="card-text">
                            <br></br><br></br>
                            <h2 className="featured h3" >My contribution to the project:</h2><br></br>
                            <span className="">Database re-engineering, Application Logic,Application caching,Session Caching, Frontend Programming, UI Design, UX Programming.</span>
                                    <br></br><br></br><span className="">Technologies used on this project: SQL, .NET, ASPx, XMLHttpRequest,Bootstrap,Javascript,JQuery, CSS, HTML5.</span>
                                    </div>
                            </div>
                        </div>
                        
                           
                        </div>
                    </div>

                    <div className="card">
                    <h3>Other Projects (Local)</h3>
                        <div className="row">
                        
                            <div className="text-center col-lg-6">
                                <a href={projectothers1} target="_blank" rel="noopener noreferrer" className="col-lg-3"><img alt="project screenshot"src={projectothers1} /></a>                            
                            </div>
                            <div className="text-start col-lg-6">
                                <div className="col-lg-12">
                                    <div className="card-text">
                                    <br></br><br></br>
                                    <h2 className="featured h3" >About the Project:</h2><br></br>
                                        <p>
                                        Web Re-design for the George Jeffrey Children's Foundation.                                            
                                        </p>                                    
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >My contribution to the project:</h2><br></br>
                                <span className="">Web Design UI/UX, creation of HTML & CSS code to implement with the company CMS.</span>
                                        <br></br><br></br><span className="">Technologies used on this project: CSS, HTML5, Photoshop and Illustrator.</span>
                                        </div>
                                </div>
                            </div>
                        
                           
                        </div>
                    </div>  
                    <div className="card">
                    <h3>Other Projects (Local)</h3>
                        <div className="row">                        
                            <div className="text-center col-lg-6 row">
                            <div className="col-lg-5 img-thumbnail card-body"  style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers5} /></div>
                                <div className="col-lg-5 img-thumbnail card-body"  style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers6} /></div>
                                <div className="col-lg-5 img-thumbnail card-body"  style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers7} /></div>
                                <div className="col-lg-5 img-thumbnail card-body"  style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers8} /></div>
                                <div className="col-lg-5 img-thumbnail card-body" style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers2}  /></div>
                                <div className="col-lg-5 img-thumbnail card-body"  style={{display: "flex",alignItems: "center"}}><img alt="project screenshot" src={projectothers3} style={{maxHeight:"120px",margin:"auto"}}/></div>
                                
                                
                            </div>
                            <div className="text-start col-lg-6">
                             
                                <div className="col-lg-12">
                                <div className="card-text">
                                <br></br><br></br>
                                <h2 className="featured h3" >My contribution to the projects:</h2><br></br>
                                <span className="">I had worked with multiple local (Thunder Bay) organizations and companies in a successful manner.<br></br><br></br>
                                 From Non-profit to small business always with the highest professional standards to 
                                fulfill the needs of the projects.<br></br>
<br></br>
                                I contributed in projects with these and other companies providing either web development programming, graphic / web design or has a direct client contact.
                                </span>
                                        
                                        </div>
                                </div>
                            </div>
                        
                           
                        </div>
                    </div>         
                </Slider>
               
            </div>
           
               
            </div>
            
            <Link to="contact" spy={true} smooth={true}>
                <h2 className="arrow-bottom"><i className="fa fa-arrow-circle-down"></i></h2>
            </Link>

        </div>
        )    
}

export default resumeportafolio;
